/**
 * @generated SignedSource<<3fcf6e3f988bb4f9d297ad994803933d>>
 * @relayHash 0865c8da47efa2ac089fbe78c74dc438
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0865c8da47efa2ac089fbe78c74dc438

import { ConcreteRequest } from 'relay-runtime';
export type BetterDocConsultationReason = "FIRST_SPECIALIST_CONSULTATION" | "SECOND_OPINION" | "SPECIALIST_CHANGE_PREFERRED" | "SPECIALIST_DIAGNOSTIC_PROCEDURE" | "SPECIALIST_HIGHER_SPECIALIZATION_WANTED" | "SPECIALIST_PREVENTIVE_CARE" | "SURGEON_WANTED";
export type BetterDocResultStatus = "BETTER_DOC_ERROR" | "INVALID_PATIENT" | "INVALID_SPECIALTY" | "MANUAL_SEARCH_NEEDED" | "NO_RESULTS" | "SUCCESS";
export type CareProviderGroupType = "CHIROPRACTOR" | "DENTIST" | "DOCTOR" | "HOSPITAL" | "NONE" | "NUTRITIONIST" | "PHARMACY" | "PHYSIOTHERAPIST" | "PSYCHOTHERAPIST";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type Ch_betterDocRecommendationsInput = {
  address: AddressInput;
  bodyMassIndex?: number | null;
  consultationReason: BetterDocConsultationReason;
  currentMedications: ReadonlyArray<string>;
  effectivePointOfCare: PointOfCareType;
  episodeOfCareIcd10Code?: string | null;
  healthInformationConditionIcd10Codes: ReadonlyArray<string>;
  insurance: BetterDocPatientInsuranceInput;
  language: Language;
  patientId: string;
  phoneNumber: string;
  progressNoteAnamnesis?: string | null;
  progressNoteId: string;
  specialtyId?: string | null;
  subSpecialtyName?: string | null;
};
export type AddressInput = {
  city: string;
  countryCode: string;
  houseNumberStreet: string;
  postalCode: string;
};
export type BetterDocPatientInsuranceInput = {
  insureeNumber: string;
  organizationName: string;
  productKey: string;
};
export type betterDocRecommendationsQuery$variables = {
  input: Ch_betterDocRecommendationsInput;
  language: string;
};
export type betterDocRecommendationsQuery$data = {
  readonly ch_betterDocRecommendations: {
    readonly careProviders: ReadonlyArray<{
      readonly __typename: "CareProvider";
      readonly businessName: string | null;
      readonly careProviderGroup: {
        readonly groupType: CareProviderGroupType;
      };
      readonly careProviderSpecialtyTranslations: ReadonlyArray<{
        readonly name: string;
      }>;
      readonly city: string | null;
      readonly country: {
        readonly countryName: string | null;
      } | null;
      readonly firstName: string | null;
      readonly groupName: string | null;
      readonly id: string;
      readonly lastName: string | null;
      readonly postalCode: string | null;
      readonly relationBusinessName: string | null;
      readonly relationFirstName: string | null;
      readonly relationLastName: string | null;
      readonly relationTitle: string | null;
      readonly relationType: string | null;
      readonly streetAddress: string | null;
      readonly title: string | null;
    }>;
    readonly status: BetterDocResultStatus;
  };
};
export type betterDocRecommendationsQuery = {
  response: betterDocRecommendationsQuery$data;
  variables: betterDocRecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v10 = {
  "alias": null,
  "args": (v9/*:: as any*/),
  "kind": "ScalarField",
  "name": "groupName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetAddress",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": (v9/*:: as any*/),
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationBusinessName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationFirstName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationLastName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationTitle",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocRecommendationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ch_BetterDocRecommendationsOutput",
        "kind": "LinkedField",
        "name": "ch_betterDocRecommendations",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CareProvider",
            "kind": "LinkedField",
            "name": "careProviders",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderGroup",
                "kind": "LinkedField",
                "name": "careProviderGroup",
                "plural": false,
                "selections": [
                  (v11/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v9/*:: as any*/),
                "concreteType": "SpecialtyTranslation",
                "kind": "LinkedField",
                "name": "careProviderSpecialtyTranslations",
                "plural": true,
                "selections": [
                  (v12/*:: as any*/)
                ],
                "storageKey": null
              },
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v16/*:: as any*/)
                ],
                "storageKey": null
              },
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocRecommendationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ch_BetterDocRecommendationsOutput",
        "kind": "LinkedField",
        "name": "ch_betterDocRecommendations",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CareProvider",
            "kind": "LinkedField",
            "name": "careProviders",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderGroup",
                "kind": "LinkedField",
                "name": "careProviderGroup",
                "plural": false,
                "selections": [
                  (v11/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v9/*:: as any*/),
                "concreteType": "SpecialtyTranslation",
                "kind": "LinkedField",
                "name": "careProviderSpecialtyTranslations",
                "plural": true,
                "selections": [
                  (v12/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v16/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0865c8da47efa2ac089fbe78c74dc438",
    "metadata": {},
    "name": "betterDocRecommendationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8de37bb42022a5b44e58d0a54bb5d4a7";

export default node;
